/**
 * CSRF token handling for HTMX requests.
 *
 * Injects X-CSRFToken header on every HTMX mutation (POST/PUT/DELETE/PATCH)
 * by reading the csrftoken cookie. Also handles 403 responses with a
 * refresh prompt (likely expired CSRF).
 */

(function () {

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function getCsrfToken() {
        return getCookie('csrftoken_houses') || getCookie('csrftoken');
    }

    window._cc = window._cc || {};
    window._cc.getCsrfToken = getCsrfToken;

    document.body.addEventListener('htmx:configRequest', function (e) {
        var token = getCsrfToken();
        if (token) e.detail.headers['X-CSRFToken'] = token;
    });

    document.body.addEventListener('htmx:responseError', function (e) {
        // A 403 whose body is "Permission denied." is a refused action on a live
        // session; acqs-ws.js toasts that body itself.
        if (e.detail.xhr.status === 403 && window.SeeMe && SeeMe.toast
            && e.detail.xhr.responseText.indexOf('Permission denied.') === -1) {
            SeeMe.toast.error('Session expired — please refresh the page');
        }
    });

})();
